import { Music24PlanTier } from 'fym-shared/src/music24/music24Plans';
import { useLicenseInfo } from '../../../redux/slices/license/hooks/hooks';
import { useUserTokenDecoded } from '../../../redux/slices/appInfo/hooks';

/**
 * The signed-in user's Music24 plan tier.
 *
 * The `license` redux slice is the source: the trial fields (`isTrialActive`,
 * `trialDaysRemaining`) come from the same object, so the two never disagree. The decoded JWT
 * can lag behind it (the app refreshes the token only on sign-in and renewal), so it is only a
 * fallback for the moment before the licence slice loads.
 */
export function useMusic24Plan(): Music24PlanTier {
  const licenseInfo = useLicenseInfo();
  const userTokenDecoded = useUserTokenDecoded();
  return licenseInfo.license?.smlCapabilities?.plan ?? userTokenDecoded?.licenseInfo?.smlCapabilities?.plan ?? 'free';
}
